function openDataIntelligencePopup() {
  document.getElementById('data-intelligence-popup').classList.add('is-active');
}

function closeDataIntelligencePopup() {
  document.getElementById('data-intelligence-popup').classList.remove('is-active');
}

document.addEventListener('DOMContentLoaded', function () {

  const form = document.getElementById('data-intelligence-form');
  if (!form) return;

  form.addEventListener('submit', async function (e) {

    e.preventDefault();

    const submitButton = form.querySelector('button[type="submit"]');
    const originalText = submitButton.innerHTML;

    submitButton.disabled = true;

    submitButton.innerHTML = `
      <span class="supplier-loading">
        <span class="spinner"></span>
        Submitting
      </span>
    `;

    try {

      const formData = new FormData(form);

      const response = await fetch(form.action, {
        method: 'POST',
        body: formData
      });

      if (!response.ok) throw new Error('Submission failed');

      form.innerHTML = `
        <div class="supplier-success">
          <p><strong>Insights received.</strong></p>
          <p>Thank you for helping us understand cooperative operations.</p>
        </div>
      `;

      setTimeout(function () {
        closeDataIntelligencePopup();
        form.reset();
      }, 4000);

    } catch (error) {

      submitButton.disabled = false;
      submitButton.innerHTML = originalText;

      alert('Submission failed. Please try again.');

    }

  });

});

document.addEventListener('click', function(e) {
  var t = e.target.closest('[data-bc-data-intelligence-trigger]');
  if (!t) return;
  e.preventDefault();
  openDataIntelligencePopup();
});